export type SipMode = 'projection' | 'goal'

export type RememberedSipInput = {
  mode: SipMode
  monthlyInvestment: string
  annualReturnPercent: string
  years: string
  annualStepUpPercent: string
  inflationPercent: string
  targetValue: string
}

export type RememberedCagrInput = { mode: 'growth' | 'cagr' | 'target'; first: string; second: string; years: string; inflationPercent: string; compareReturnPercent: string }
export type RememberedEmiInput = { principal: string; annualInterestPercent: string; tenureMonths: string; extraMonthly: string }
export type SavedSipPlan = { id: string; name: string; input: RememberedSipInput; savedAt: string }

export const defaultSipInput: RememberedSipInput = {
  mode: 'projection',
  monthlyInvestment: '10000',
  annualReturnPercent: '12',
  years: '10',
  annualStepUpPercent: '0',
  inflationPercent: '6',
  targetValue: '2500000',
}

export const defaultCagrInput: RememberedCagrInput = { mode: 'growth', first: '100000', second: '12', years: '10', inflationPercent: '6', compareReturnPercent: '' }
export const defaultEmiInput: RememberedEmiInput = { principal: '1000000', annualInterestPercent: '10', tenureMonths: '120', extraMonthly: '0' }

export function normalizeRememberedSip(input: Partial<RememberedSipInput> | null | undefined): RememberedSipInput {
  return {
    ...defaultSipInput,
    ...input,
    mode: input?.mode === 'goal' ? 'goal' : 'projection',
  }
}

export function normalizeRememberedCagr(input: Partial<RememberedCagrInput> | null | undefined): RememberedCagrInput {
  const mode = input?.mode === 'cagr' || input?.mode === 'target' ? input.mode : 'growth'
  return { ...defaultCagrInput, ...input, mode }
}

export function normalizeRememberedEmi(input: Partial<RememberedEmiInput> | null | undefined): RememberedEmiInput {
  return { ...defaultEmiInput, ...input }
}
